/**
 * An auto-send switch the server refused, in words a person can act on
 * (26/10/2026, user: "fix the error pop up please into a logical message"):
 * each known refusal sentence says what is off and where to fix it, and the
 * all-groups toast says what did not switch, why, and whether the others did.
 * For Media Devoted | Created By Ciro Autiero
 */
import type { DropGenAutoSendMode } from '@trafficpulse/shared';

const PLAIN: Array<[string, string]> = [
  ['Enable the plan first.', "This country's plan is switched off — press Enable plan at the top of the page, then switch auto-send on."],
  ['The kill switch is on — restore it before auto-send.', 'Kill is on for this country — restore it at the top of the page first.'],
];

/** The server's sentences, the known ones in plain words; always ends as a sentence. */
export const refusalWords = (message: string): string => {
  const text = PLAIN.reduce((out, [from, to]) => out.replace(from, to), message).trim();
  return /[.!?]$/.test(text) ? text : `${text}.`;
};

const TITLE: Record<DropGenAutoSendMode, string> = {
  on: 'Auto-send was not switched on',
  shadow: 'Simulated was not switched on',
  off: 'Auto-send was not switched off',
};

export interface Refused {
  name: string;
  reason: string;
}

/** The toast when some groups refused: one shared reason said once, else each group with its own. */
export function refusalToast(mode: DropGenAutoSendMode, refused: Refused[], switched: number): { title: string; body: string } {
  const reasons = new Set(refused.map((r) => r.reason));
  const others = switched > 0 ? ` The other ${switched === 1 ? 'group' : `${switched} groups`} switched.` : '';
  const title = switched > 0 ? `${TITLE[mode]} everywhere` : TITLE[mode];
  if (reasons.size === 1)
    return { title, body: `${[...reasons][0]} Not switched: ${refused.map((r) => r.name).join(', ')}.${others}` };
  return { title, body: `${refused.map((r) => `${r.name}: ${r.reason}`).join(' · ')}${others}` };
}
